import React from 'react';
import { Box, Text, Flex, Button } from 'pounceV2';
import useModalV3 from 'Hooks/useModalV3';

type ConfirmModalVariants = 'destructive' | 'continue';

export interface ConfirmModalProps {
  subtitle: React.ReactNode;
  onCloseOptimistic?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
  variant?: ConfirmModalVariants;
  textAlign?: 'center' | 'left' | 'right';
  cancelBtnText?: string;
  confirmBtnText?: string;
  loading?: boolean;
}

export const ConfirmModalV3: React.FC<ConfirmModalProps> = ({
  subtitle,
  onConfirm,
  onClose,
  onCloseOptimistic,
  variant = 'continue',
  textAlign = 'center',
  cancelBtnText = 'Cancel',
  confirmBtnText,
  loading = false,
}) => {
  const { hideModal } = useModalV3();

  const handleConfirm = () => {
    hideModal();
    onConfirm();
  };
  const hideModalOptimistic = () => {
    hideModal();
    if (onCloseOptimistic) {
      onCloseOptimistic();
    }
  };

  // Close the modal automatically after the confirmation action is taken
  // If `false`, it is up to the `onClose` prop provided to close the modal.
  const isOptimistic = !onClose;

  return (
    <Box maxWidth={700}>
      <Text mb={8} textAlign={textAlign} id="modal-subtitle">
        {subtitle}
      </Text>
      <Flex justify="flex-end" gap={3}>
        <Button variant="outline" onClick={isOptimistic ? hideModalOptimistic : onClose}>
          {cancelBtnText}
        </Button>
        <Button
          variant={variant === 'destructive' ? 'destructive' : undefined}
          onClick={isOptimistic ? handleConfirm : onConfirm}
          loading={loading}
          disabled={loading}
        >
          {confirmBtnText || (variant === 'continue' ? 'Continue' : 'Confirm')}
        </Button>
      </Flex>
    </Box>
  );
};
